// src/lib/portalTheme.js
// Portal-wide map theming. Every map's tiles use
//   filter: var(--map-tiles-filter, <midnight default>)
// so changing the CSS variable re-skins every map in the app at once.
// The choice lives server-side (PortalSetting 'mapTheme') so it applies to
// everyone; localStorage caches it so maps paint right on first render.
import axios from 'axios';
import { API_BASE } from '../apiBase';

export const MAP_THEMES = {
  midnight: {
    label: 'Midnight (default)',
    filter: 'invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%) grayscale(35%)',
  },
  slate: {
    label: 'Slate',
    filter: 'invert(100%) hue-rotate(180deg) brightness(90%) contrast(85%) grayscale(85%)',
  },
  charcoal: {
    label: 'Charcoal',
    filter: 'invert(100%) hue-rotate(180deg) brightness(72%) contrast(115%) grayscale(60%)',
  },
  indigoNight: {
    label: 'Indigo Night',
    filter: 'invert(100%) hue-rotate(235deg) brightness(90%) contrast(95%) grayscale(10%)',
  },
  emeraldNight: {
    label: 'Emerald Night',
    filter: 'invert(100%) hue-rotate(120deg) brightness(88%) contrast(95%) grayscale(20%)',
  },
};
export const DEFAULT_MAP_THEME = 'midnight';

// Preview only — swaps the CSS variable on THIS device without persisting.
export const applyMapTheme = (key) => {
  const theme = MAP_THEMES[key] || MAP_THEMES[DEFAULT_MAP_THEME];
  document.documentElement.style.setProperty('--map-tiles-filter', theme.filter);
};

// Call once at app start: paint from the local cache instantly, then sync
// with the server-side setting (in case another device changed it).
export const initPortalTheme = () => {
  let cached = DEFAULT_MAP_THEME;
  try { cached = localStorage.getItem('portal.mapTheme') || DEFAULT_MAP_THEME; } catch (_) {}
  applyMapTheme(cached);
  const token = localStorage.getItem('token');
  if (!token) return;
  axios.get(`${API_BASE}/portal-settings`, { headers: { Authorization: token } })
    .then(r => { if (r.data && r.data.mapTheme) applyMapTheme(r.data.mapTheme); })
    .catch(() => {});
};

// Save = apply + cache locally + persist portal-wide.
export const saveMapTheme = (key) => {
  applyMapTheme(key);
  try { localStorage.setItem('portal.mapTheme', MAP_THEMES[key] ? key : DEFAULT_MAP_THEME); } catch (_) {}
  return axios.put(`${API_BASE}/portal-settings`, { key: 'mapTheme', value: key },
    { headers: { Authorization: localStorage.getItem('token') } });
};
